angular.module('gym.access_control').controller('AccessControlSettingsCtrl', ["$scope", "$rootScope", "$modal", "$state", "ngTableParams", "AccessControl", "settings", function($scope, $rootScope, $modal, $state, ngTableParams, AccessControl, settings) {
  var Settings, ref;
  $scope.settings = settings[0];
  $scope.gym = $rootScope.gym;
  if (!((ref = $scope.settings) != null ? ref.authorized : void 0)) {
    $state.go('gym.dashboard');
    return;
  }
  $scope.authorizeUrl = `/gyms/${$scope.gym.id}/access_control/settings/auth`;
  $scope.authToken = $('meta[name=csrf-token]').attr('content');
  $scope.currentTab = 'active';
  Settings = AccessControl.all('settings');
  $scope.setTab = function(tab) {
    return $scope.currentTab = tab;
  };
  $scope.reAuthorize = function() {
    return angular.element('#authorize-form')[0].submit();
  };
  $scope.showSettings = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/access_control/settings_modal.html.slim'),
      controller: 'AccessControlSettingsModalCtrl',
      resolve: {
        settings: function() {
          return $scope.settings;
        }
      }
    });
    return modalInstance.result.then(function() {
      return $scope.settings.get().then(function(data) {
        return $scope.settings = data;
      });
    });
  };
  $scope.enabledContactsTableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      return Settings.all('contacts_enabled_on_brivo').getList($params.url()).then(function(data) {
        $scope.enabledContacts = data;
        $params.total(data.meta.total);
        return $defer.resolve(data);
      });
    }
  });
  $scope.disabledContactsTableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      return Settings.all('contacts_disabled_on_brivo').getList($params.url()).then(function(data) {
        $scope.disabledContacts = data;
        $params.total(data.meta.total);
        return $defer.resolve(data);
      });
    }
  });
  $scope.contactsNotOnBrivoTableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      return Settings.all('contacts_not_on_brivo').getList($params.url()).then(function(data) {
        $scope.contactsNotOnBrivo = data;
        $params.total(data.meta.total);
        return $defer.resolve(data);
      });
    }
  });
  $scope.accessControlGroupsTableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      return AccessControl.all('groups').getList($params.url()).then(function(data) {
        $scope.groups = data;
        $params.total(data.meta.total);
        return $defer.resolve(data);
      });
    }
  });
  return $scope.reloadGroups = function() {
    return $scope.accessControlGroupsTableParams.reload();
  };
}]);
